// Google Analytics 4 Configuration
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || '';

// DSGVO-compliant Google Analytics setup
export const initializeGA = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Check if GA is already initialized
  if (typeof window.gtag === 'function' && window.dataLayer) {
    return;
  }

  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    anonymize_ip: true, // DSGVO: IP-Anonymisierung
    allow_google_signals: false, // DSGVO: Keine Google Signals
    allow_ad_personalization_signals: false, // DSGVO: Keine Ad-Personalisierung
  });
};

// Page view tracking
export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Custom event tracking
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Donation tracking
export const trackDonation = (amount?: number, cause?: string) => {
  trackEvent('donation_click', 'engagement', cause, amount);
};

// Social media tracking
export const trackSocialClick = (platform: string) => {
  trackEvent('social_click', 'engagement', platform);
};

// Declare global types
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}
